import { formatNumber } from '@monetize/utils/core';
import { useState } from 'react';
import { useGetRate } from '../../../../../api/productCatalogService';
import {
  MAccordionButton,
  MAccordionIcon,
  MAccordionItem,
  MAccordionPanel,
  MFlex,
  MIDCopyBox,
  MSpinner,
  MText,
} from '../../../../../components/Monetize';
import { MCurrency } from '../../../../../components/Monetize/MCurrency';
import { AccountLookupPopover } from '../../../../../components/Monetize/LookupPopover';
import { PRICE_MODEL_OPTIONS } from '../../../../../constants/offerings';
import { getOrderedPricesUnderProduct } from '../../../../../utils/product';
import CustomRateProductsWithPrice from './CustomRateProductsWithPrice';

interface CustomRateAccordionItemProps {
  value: string;
  rateId: string;
  name: string;
  createDate: string;
  accountName: string;
  accountId: string;
  currency: string;
}
export const CustomRateAccordionItem = ({
  value,
  rateId,
  name,
  createDate,
  accountName,
  accountId,
  currency,
}: CustomRateAccordionItemProps) => {
  const [isExpanded, setIsExpanded] = useState<boolean>(false);
  const { isLoading, data } = useGetRate(rateId, {
    enabled: isExpanded,
  });
  const productsWithPrice = data ? getOrderedPricesUnderProduct(data) : [];

  const renderSpinner = () => {
    return (
      <MFlex justifyContent="center" alignItems="center" h="full">
        <MSpinner />
      </MFlex>
    );
  };

  const renderProductWithPrice = () => {
    return (
      <>
        {productsWithPrice.map(({ id: key, name: productName, prices }) => (
          <CustomRateProductsWithPrice key={key} productName={productName}>
            <>
              {prices.map(
                ({ id: priceId, priceModel, from, to, amount }, idx) => (
                  <MFlex
                    key={`${idx}-${priceId}`}
                    justifyContent="space-between"
                    color="tPurple.dark"
                    pl={2}
                    gap={2}
                    w="full"
                  >
                    <MText fontSize="sm" fontWeight="normal" flex="1">
                      {PRICE_MODEL_OPTIONS[priceModel]}
                    </MText>
                    <MFlex>
                      <MText fontWeight="normal" fontSize="sm">{`${formatNumber(
                        from,
                        {
                          maximumFractionDigits: 0,
                        },
                      )} - ${
                        formatNumber(to, {
                          maximumFractionDigits: 0,
                        }) || '∞'
                      }`}</MText>
                    </MFlex>
                    <MCurrency
                      flex="1"
                      fontSize="sm"
                      fontWeight="normal"
                      textAlign="right"
                      amount={amount}
                      options={{ maximumFractionDigits: 'max', currency }}
                    />
                  </MFlex>
                ),
              )}
            </>
          </CustomRateProductsWithPrice>
        ))}
      </>
    );
  };
  return (
    <MAccordionItem
      value={value}
      borderTop="none"
      borderLeft="none"
      borderRight="none"
      borderWidth="1px"
      borderColor="tGray.back"
    >
      <MAccordionButton
        px={0}
        onClick={() => setIsExpanded(!isExpanded)}
        _active={{ bg: 'none' }}
        _hover={{ bg: 'none' }}
      >
        <MFlex
          justifyContent="space-between"
          alignItems="center"
          w="full"
          columnGap={4}
        >
          <MFlex
            direction="column"
            justifyContent="flex-start"
            textAlign="left"
            flex={1}
          >
            <MText
              color="tPurple.dark"
              lineClamp={1}
              fontWeight="medium"
              fontSize="sm"
            >
              {name}
            </MText>
            <MIDCopyBox
              copyValue={rateId}
              color="tGray.acGray"
              fontWeight="normal"
              fontSize="xs"
              displayIcon={false}
            />
            {/* <MText color="tGray.acGray" fontWeight="normal" fontSize="xs">
              {toDateShort(createDate)}
            </MText> */}
          </MFlex>

          <MFlex flex={1} justifyContent="flex-end" textAlign="right" gap={2}>
            <MFlex flexDirection="column">
              <MText
                color="tPurple.dark"
                fontWeight="normal"
                fontSize="sm"
                lineClamp={1}
              >
                {accountName}
              </MText>
              <MFlex justifyContent="flex-end">
                <AccountLookupPopover value={accountId} />
              </MFlex>
            </MFlex>
            <MAccordionIcon color="tPurple.dark" />
          </MFlex>
        </MFlex>
      </MAccordionButton>

      <MAccordionPanel pr={0} pt={0} pb={4}>
        {isLoading ? renderSpinner() : renderProductWithPrice()}
      </MAccordionPanel>
    </MAccordionItem>
  );
};
